import type { ReactNode } from 'react';

import FunnelStageCard from 'containers/user/critical-elements-monitoring/components/funnel-stage-card';
import type { StageCardDisplayMode } from 'containers/user/critical-elements-monitoring/components/funnel-stage-card';
import {
  getExtensionDisplayLabel,
  isFunnelRowCohortUnavailable,
} from 'containers/user/critical-elements-monitoring/monitoring-constants';
import type {
  CompareTo,
  ExtensionMetric,
} from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

export interface ExtensionCardProps {
  metric: ExtensionMetric;
  compareTo: CompareTo;
  displayMode: StageCardDisplayMode;
  cohortLabel: string;
  headerAction?: ReactNode;
}

const FINANCIAL_AID_RATE_CAPTION = 'Proportion of admits';

const getSecondaryCaption = (
  metric: ExtensionMetric,
  displayMode: StageCardDisplayMode
): string => {
  if (metric.type === 'financial-aid') {
    return displayMode === 'rate' ? FINANCIAL_AID_RATE_CAPTION : '';
  }

  return metric.secondaryCaption;
};

const ExtensionCard = ({
  metric,
  compareTo,
  displayMode,
  cohortLabel,
  headerAction,
}: ExtensionCardProps) => (
  <FunnelStageCard
    stageLabel={getExtensionDisplayLabel(metric.type, displayMode)}
    metric={metric}
    compareTo={compareTo}
    displayMode={displayMode}
    cohortLabel={cohortLabel}
    secondaryCaption={getSecondaryCaption(metric, displayMode)}
    hideBarsSection={metric.type === 'retention'}
    dataStatus={metric.dataStatus}
    cohortDataUnavailable={isFunnelRowCohortUnavailable(
      metric.type,
      displayMode
    )}
    headerAction={headerAction}
  />
);

export default ExtensionCard;
